export const WIDGET_GET_PENDING_CALLS_MESSAGES = 'widget-get-pending-calls-messages';
export const WIDGET_GET_PENDING_CALLS_MESSAGES_RESULT = `${WIDGET_GET_PENDING_CALLS_MESSAGES}/result`;
export const WIDGET_GET_PENDING_CALLS_MESSAGES_ERROR = `${WIDGET_GET_PENDING_CALLS_MESSAGES}/error`;
